'use client'
import { Box, Link, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslations } from 'next-intl'
import { IProduct } from '@/app/[locale]/_types'
import { useCustomLocale } from '@/app/[locale]/_hooks/useCustomLocale'

function Description({ data }: { data: IProduct | null | undefined }) {
  const [showMore, setShowMore] = useState(false)
  const currentLocale = useCustomLocale()
  const t = useTranslations()
  const description = data?.description?.[currentLocale]?.trim()

  if (!description) {
    return null // Return early if there's no description
  }

  const isLongDescription = description.length > 140

  return (
    <>
      <Box mb={2} fontSize="sm" lineHeight="18px" position="relative">
        <Text as="pre" font="inherit" whiteSpace="pre-wrap" color="text.muted">
          {showMore ? description : description.substring(0, 140)}
        </Text>
        {isLongDescription && !showMore && (
          <Box
            position="absolute"
            top={0}
            left={0}
            w="full"
            h="full"
            bgGradient="linear(to-b, transparent, #1A1A1A)"
            opacity={1}
            transition="150ms ease-in-out"
          ></Box>
        )}
      </Box>
      {isLongDescription && (
        <Text
          w="fit-content"
          color="primary"
          fontSize="xs"
          as={Link}
          fontWeight={400}
          transform="translateY(-5px)"
          onClick={() => setShowMore((prev) => !prev)}
        >
          {showMore ? t('show_less') : t('show_more')}
        </Text>
      )}
    </>
  )
}

export default Description
